.<template>
  <h3
    class="text-color-topaz-light font-museo-500 related-title xs:pl-0 pl-[0.813rem]"
  >
    {{ $t("profiles.titles.relatedArtists") }}
  </h3>
  <div class="slider-gradient"></div>
  <carousel
    :breakpoints="breakpointSwitch"
    :transition="500"
    :wrap-around="false"
    class="carousel fixed-carousel-arrows"
    :aria-label="$t('profiles.titles.relatedArtists')"
    @mousedown="handleMouseDown"
    @mousemove="cancelOpen"
    @mouseup="handleMouseUp"
  >
    <slide
      v-for="(artist, index) in artistsRelated"
      :key="artist.id"
      :aria-hidden="false"
    >
      <artist-card
        v-if="artist"
        :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
        :artist="artist"
        :is-link="showLink"
        type="small"
      />
    </slide>
  </carousel>
</template>

<script setup>
import { BREAKPOINTS } from "@/constants.js";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import ArtistCard from "@/components/wegow/ui/cards/ArtistCard.vue";
import { computed, ref } from "vue";

const props = defineProps({
  artistsRelated: {
    type: Array,
    default: undefined
  },
  breakpoints: {
    type: String,
    default: "short"
  }
});
const showLink = ref(true);
const isClicking = ref(true);
const breakpointSwitch = computed(() => {
  switch (props.breakpoints) {
    case "large":
      return BREAKPOINTS.largeSectionProfileRelated;
    case "small":
      return BREAKPOINTS.smallEventCard;
    case "small-short":
      return BREAKPOINTS.smallArtistRelated;
    default:
      return BREAKPOINTS.eventProfileRelated;
  }
});
const handleMouseDown = () => {
  isClicking.value = true;
};
const cancelOpen = () => {
  if (isClicking.value && showLink.value) {
    showLink.value = false;
  }
};
const handleMouseUp = () => {
  if (isClicking.value) {
    setTimeout(() => {
      isClicking.value = false;
      showLink.value = true;
    }, 250);
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
</style>
